import { FC } from "react";

import { StarredToggleWrapper } from "./header-starred-button.styled";
import {
  StarredButtonContext,
  StarredButtonGroup,
  StarredDropdownArea,
  useStarredButtonContextProvider,
} from "./parts";

export const HeaderStarredButton: FC = () => {
  const hookData = useStarredButtonContextProvider();
  return (
    <StarredButtonContext.Provider value={hookData}>
      <StarredToggleWrapper>
        <StarredButtonGroup />
        <StarredDropdownArea />
      </StarredToggleWrapper>
    </StarredButtonContext.Provider>
  );
};
